import Logo from "../../Atoms/Logo/Logo";
import "./PageFooter.scss";
import FS_LOGO_BLANCO from "../../../assets/img/FS-LOGO-BLANCO.svg";
import FS_HOME_GOOGLEPLAY_BOTON from "../../../assets/img/FS-HOME-GOOGLEPLAY-BOTON.png";
import FS_HOME_APPSTORE_BOTON from "../../../assets/img/FS-HOME-APPSTORE-BOTON.png";
import { Button } from "../../Atoms/Button/Button";
import { Link } from "wouter";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import content from "./content";

const PageFooter = () => {
	const {language} = useLanguageCtx();

	return (
		<footer className="page-footer">
			<div className="max-width page-footer--container">
				<div className="page-footer--container-row-1">
					<div className="mt-20">
						<Logo url={FS_LOGO_BLANCO} footer />
					</div>
					<div className="mt-20">
						<p className="no-space c-white body-14">
							{content[language].linkedin_text}
						</p>
						<p className="no-space c-white body-14 m-word-no-wrap">
							{content[language].copyright_text}{" "}
							<span className="link">{content[language].copyright_span}</span>
						</p>
					</div>
				</div>

				<div className="page-footer--container-row-2">
					<div className="mt-20">
						<p className="no-space c-white body-14 bold">
							{content[language].acerca_title}
						</p>

						<Link href="/acerca">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].acerca_link_1}
							</p>
						</Link>
						<Link href="/carreras">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].acerca_link_2}
							</p>
						</Link>
						<Link href="/noticias">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].acerca_link_3}
							</p>
						</Link>
						<Link href="/casos-de-exito">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].acerca_link_4}
							</p>
						</Link>
					</div>
					<div className="mt-20">
						<p className="no-space c-white body-14 bold">
							{content[language].recursos_title}{" "}
						</p>
						<Link href="/recursos/soporte">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].recursos_link_1}
							</p>
						</Link>
						<Link href="/recursos/preguntas-frecuentes">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].recursos_link_2}
							</p>
						</Link>
						<Link href="/recursos/tutoriales">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].recursos_link_3}
							</p>
						</Link>
						<Link href="/contacto">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].recursos_link_4}
							</p>
						</Link>
					</div>
				</div>

				<div className="page-footer--container-row-3">
					<div className="mt-20">
						<p className="no-space c-white body-14 bold">
							{content[language].servicios_title}
						</p>
						<Link href="/industry/equipo-pesado">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].servicios_link_1}
							</p>
						</Link>
						<Link href="/family/my-tracker">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].servicios_link_2}
							</p>
						</Link>
					</div>
					<div className="mt-20">
						<p className="no-space c-white body-14 bold">
							{content[language].soluciones_title}
						</p>
						<Link href="/solutions/g-evolution">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].soluciones_link_1}
							</p>
						</Link>
						<Link href="/solutions/aplicaciones-moviles">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].soluciones_link_2}
							</p>
						</Link>
						<Link href="/solutions/telematica">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].soluciones_link_3}
							</p>
						</Link>
						<Link href="/solutions/servicios">
							<p className="no-space c-white body-14 page-footer--link">
								{content[language].soluciones_link_4}
							</p>
						</Link>
					</div>
				</div>

				<div className="page-footer--container-row-4">
					<div className="mt-20">
						<p className="no-space c-white body-14 bold">
							{content[language].oficinas_title}
						</p>
						<p className="no-space c-white body-14"> Miami, Florida - USA</p>
						<p className="no-space c-white body-14">
							+1(305) 398.38.66 11890 SW 8th Street. Suite 404.
						</p>
						<p className="no-space c-white body-14">Miami. Fl. 33184</p>
						<p className="no-space c-white body-14 link">
							<a className="no-space c-white body-14 link" href="https://www.google.com/maps/place/SW+8th+St,+Miami,+FL+33184,+EE.+UU./@25.7595581,-80.4229945,17z/data=!4m5!3m4!1s0x88da2019d1fe9fbb:0xb26a079b45ff462b!8m2!3d25.7610607!4d-80.4209024" target="_blank" rel="noopener noreferrer">
								{content[language].mapa_text}
							</a>
						</p>
					</div>
					<div className="mt-20">
						<p className="no-space c-white body-14"> Caracas - Venezuela</p>
						<p className="no-space c-white body-14">
							+58 (212) 313.50.00 Calle Pantín, Urb. Chacao, Caracas.
						</p>
						<p className="no-space c-white body-14 link">
							<a className="no-space c-white body-14 link" href="https://www.google.com/maps/place/Calle+Pantin,+Caracas,+Miranda/@10.4895753,-66.8571159,17.52z/data=!4m5!3m4!1s0x8c2a5855f625c8cf:0x622e8e53e8311e97!8m2!3d10.4899823!4d-66.8557975" target="_blank" rel="noopener noreferrer">
								{content[language].mapa_text}
							</a>
						</p>
					</div>
				</div>

				<div className="page-footer--container-row-5">
					<div className="btns-contaner mt-20">
						{/* <Button
							type="button yellow mb-5"
							content={content[language].button_1_text}
						/> */}
						<Button
							type="button yellow outline"
							content={content[language].button_2_text}
							buttonRoute="/recursos/soporte"
						/>
					</div>
					<div className="apps-contaner mt-20">
						<a href="https://apps.apple.com/mx/developer/foresight-gps/id1469600982" target="_blank" rel="noopener noreferrer"><img className="" src={FS_HOME_APPSTORE_BOTON} alt="APPSTORE" />	</a>
						<a href="https://play.google.com/store/apps/developer?id=ForesightGPS&hl=es_VE&gl=US" target="_blank" rel="noopener noreferrer"><img className="" src={FS_HOME_GOOGLEPLAY_BOTON} alt="GOOGLEPLAY" /></a>
					</div>
					{/* <p className="c-white body-12 ">Powered by <span className="link">Ninweb.net</span></p> */}
				</div>
			</div>
		</footer>
	);
};

export default PageFooter;
